import UIComponent from "../../common/UIComponent";
import "./index.css";
import { debounce } from "../../common/Utils";
export default class VolumeBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
  }

  init() {
    this.volumeComponent = document.createElement("div");
    this.volumeComponent.setAttribute("class", "vhallPlayer-volume-component");
    this.volumeComponent.onmouseleave = this.handleComponentMouseLeave.bind(this);

    this.volumeBtn = document.createElement("span");
    this.volumeBtn.setAttribute("class", "vhallPlayer-volume-btn");
    this.volumeBtn.onclick = this.handleBtnClick.bind(this);


    this.verticalSliderPopup = document.createElement("div");
    this.verticalSliderPopup.setAttribute('class', "vhallPlayer-verticalSlider-popup");

    this.verticalSliderBox = document.createElement("div");
    this.verticalSliderBox.setAttribute('class', "vhallPlayer-verticalSlider-box");

    this.verticalSliderRange = document.createElement("div");
    this.verticalSliderRange.setAttribute("class", "verticalSlider-range");
    this.verticalSliderRange.onclick = this.handlerRangeClick.bind(this);

    this.verticalSliderValue = document.createElement("div");
    this.verticalSliderValue.setAttribute("class", "verticalSlider-value");
    this.verticalSliderValue.style.height = `${this.interfaces.getVolume()}%`;

    this.verticalSliderCircle = document.createElement("div");
    this.verticalSliderCircle.setAttribute("class", "verticalSlider-circle");
    this.verticalSliderCircle.onmousedown = this.handlerMouseDown.bind(this);
    this.verticalSliderCircle.style.top = `${this.interfaces.getVolume()}%`;

    this.verticalSliderRange.appendChild(this.verticalSliderValue);
    this.verticalSliderRange.appendChild(this.verticalSliderCircle);
    this.verticalSliderBox.appendChild(this.verticalSliderRange);
    this.verticalSliderPopup.appendChild(this.verticalSliderBox);

    this.volumeComponent.appendChild(this.volumeBtn);
    this.volumeComponent.appendChild(this.verticalSliderPopup);
    this.appendChild(this.elementId, this.volumeComponent);

  }

  handleBtnClick() {
    this.volumeBtn.classList.add("active");
    this.verticalSliderPopup.style.display = "block";
  }

  handleComponentMouseLeave() {
    this.volumeBtn.classList.remove("active");
    this.verticalSliderPopup.style.display = "none";
  }


  handlerRangeClick(event) {
    if (event.target.className === "verticalSlider-circle") { return false; }
    const volumeValue = event.offsetY / this.verticalSliderRange.offsetHeight;
    this.interfaces.setVolume(parseInt((1 - volumeValue) * 100));
    this.verticalSliderCircle.style.top = volumeValue * 100 + '%';
    this.verticalSliderValue.style.height = (1 - volumeValue) * 100 + '%';


    if (Number(((1 - volumeValue)).toFixed(1)) === 0.0) {
      this.volumeBtn.classList.add("mute");
    } else {
      this.volumeBtn.classList.remove("mute");
    }
  }

  handlerMouseDown(event) {
    this.isMouseDown = true;
    const circleTop = this.verticalSliderCircle.offsetTop;
    const mouseY = event.clientY;
    this.verticalSliderBox.onmousemove = event => {
      const moveT = event.clientY - mouseY;
      let newT = circleTop + moveT + this.verticalSliderCircle.offsetHeight / 2;
      if (newT / this.verticalSliderRange.offsetHeight < 0 || newT / this.verticalSliderRange.offsetHeight > 1) { return; }
      this.verticalSliderCircle.style.top = newT / this.verticalSliderRange.offsetHeight * 100 + '%';
      this.verticalSliderValue.style.height = 100 - (newT / this.verticalSliderRange.offsetHeight * 100) + '%';
      if (Number((1 - newT / this.verticalSliderRange.offsetHeight).toFixed(1)) === 0.0) {
        this.volumeBtn.classList.add("mute");
      } else {
        this.volumeBtn.classList.remove("mute");
      }
      this.interfaces.setVolume(parseInt((1 - newT / this.verticalSliderRange.offsetHeight) * 100));
      // console.error(parseInt((1 - newT / this.verticalSliderRange.offsetHeight) * 100))
    }
    document.onmouseup = () => {
      if (this.isMouseDown) {
        this.verticalSliderBox.onmousemove = null;
        document.onmouseup = null;
      }
    }
  }

}